var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherNeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1213 9.87868C24.2929 11.0502 24.2929 12.9497 23.1213 14.1213C21.9497 15.2929 20.0502 15.2929 18.8787 14.1213C17.7071 12.9497 17.7071 11.0502 18.8787 9.87868C20.0502 8.70711 21.9497 8.70711 23.1213 9.87868Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1213 9.87868C15.2929 11.0502 15.2929 12.9497 14.1213 14.1213C12.9497 15.2929 11.0502 15.2929 9.87868 14.1213C8.70711 12.9497 8.70711 11.0502 9.87868 9.87868C11.0502 8.70711 12.9497 8.70711 14.1213 9.87868Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12131 9.87868C6.29288 11.0502 6.29288 12.9497 5.12131 14.1213C3.94974 15.2929 2.05024 15.2929 0.878676 14.1213C-0.292892 12.9497 -0.292892 11.0502 0.878676 9.87868C2.05024 8.70711 3.94974 8.70711 5.12131 9.87868Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherNeeds);
export default __webpack_public_path__ + "static/media/other_needs.7c6a9473ffa8da3a924093a4689ce784.svg";
export { ForwardRef as ReactComponent };